module.exports = __webpack_public_path__ + "4692a8a3baad429c38bebc70bb5f4481.jpg";